// Height (px) of transient UI occluding the viewport's bottom edge (currently MathLive's virtual
// keyboard). Published as a CSS var on <html> so containers can stay clear of it in pure CSS —
// the shared Modal shrinks into the space above the occluder (see Modal.module.scss).
const VIEWPORT_BOTTOM_INSET_VAR = '--viewport-bottom-inset';

// A write on <html> invalidates custom-property inheritance for the whole document — skip no-ops.
let lastInsetPx = 0;

export function setViewportBottomInset(px: number): void {
  const next = px > 0 ? Math.ceil(px) : 0;
  if (next === lastInsetPx) return;
  lastInsetPx = next;
  const root = document.documentElement;
  if (next > 0) root.style.setProperty(VIEWPORT_BOTTOM_INSET_VAR, `${next}px`);
  else root.style.removeProperty(VIEWPORT_BOTTOM_INSET_VAR);
}
